
export enum enumBacTokenEnableDisable {
  'N/A',
  'Disable',
  'Enable'
}

export namespace enumBacTokenEnableDisable {
  export function values() {
    return Object.keys(enumBacTokenEnableDisable).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
